<template>

  <rpm-table
      :columns="columns"
      :loading="loading"
      :data="collaboratorsFunctions"
      :pagination="pagination"
      @change-page="getCollaboratorsFunctions"
      title="Funções dos Colaboradores"
  >
    <template #functions>
      <section class="flex flex-row-reverse w-full">
        <rpm-button
            class="w-6 h-6 rounded"
            font-size="text-sm"
            icon="fa-solid fa-plus"
            @click="openModal({})"
        ></rpm-button>
      </section>
    </template>

    <template #actions="{ item }">
      <rpm-button
        icon="fa-solid fa-pen-to-square"
        color="transparent"
        tooltip-text="editar"
        @click="openModal(item)"
      ></rpm-button>
    </template>
  </rpm-table>


  <rpm-modal
    header="Atualizar Função de Colaboradores"
    class="flex flex-col gap-y-8"
    persist
    :open="modalOpen"
    @close="modalOpen = false"
  >

    <section class="flex flex-col gap-6">

      <rpm-input
          v-model="collaboratorFunction.name"
          label="Nome"
          required
          placeholder="Nome"
          :errors="errors.name"
      ></rpm-input>

    </section>

    <section class="flex flex-row justify-center gap-6">
      <rpm-button
          color="gray"
          label="Cancelar"
          @click="modalOpen = false"
      ></rpm-button>

      <rpm-button
          label="Confirmar"
          @click="save"
          :loading="saving"
      ></rpm-button>
    </section>
  </rpm-modal>

</template>


<script>

import RpmTable from "#components/RpmTable.vue";
import RpmModal from "#components/RpmModal.vue";
import Badge from "#components/Badge.vue";
import collaboratorFunctionRepository from "#repositories/collaboratorFunctionRepository";
import {request} from "#repositories/repository";
import {getErrors} from "#functions/validator.js"

export default {
  name: "CollaboratorsFunctions",
  components: {
    RpmTable,
    RpmModal,
    Badge
  },
  data() {
    return {
      loading: true,
      columns: [
        {
          field: "name",
          label: "Função",
        },
      ],
      errors: {},
      collaboratorsFunctions: [],
      collaboratorFunction: {},
      modalOpen: false,
      saving: false,
      pagination: {
        page: this.$route.query.page ?? 1,
        per_page: 10,
        last_page: 0,
        links: [],
      },
    };
  },
  methods: {
    async getCollaboratorsFunctions(page = 0) {
      if (page && page !== 0) this.pagination.page = page;

      this.loading = true;

      this.collaboratorsFunctions = request.pagination(
          await collaboratorFunctionRepository.getCollaboratorFunctions(this.pagination),
          this.pagination
      );

      this.loading = false;
    },
    openModal(item) {
      this.modalOpen = true;
      this.collaboratorFunction = item;
    },
    save() {
      this.saving = true;
      collaboratorFunctionRepository.updateCollaboratorFunction(this.collaboratorFunction.id, this.collaboratorFunction).then((response) => {
        this.$notify('Salvo com sucesso', 'success');
        this.modalOpen = false;
        this.getCollaboratorsFunctions();
      }).catch((response) => {
        getErrors(this.errors, response.errors);
        this.getCollaboratorsFunctions();
      }).finally(() => {
        this.saving = false;
      });
    }
  },
  mounted() {
    this.getCollaboratorsFunctions();
  },
}
</script>
